var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"vendors-node_modules_pnpm_survey-core_3_2_0_node_modules_survey-core_survey-core_min_css-node-e52fe8":1,"modals_AddEditHardwareId_AddEditHardwareId_jsx":1,"modals_AddESIPatientModal_AddESIPatientModal_jsx":1,"modals_DownloadHistoryModal_DownloadHistoryModal_jsx":1,"modals_DownloadMedicationModal_DownloadMedicationModal_jsx":1,"modals_EditCaregiverModal_jsx":1,"modals_EditPatientScheduleModal_EditPatientScheduleModal_jsx":1,"modals_EditStockModal_EditStockModal_jsx":1,"modals_ESIPatientEditAddressModal_ESIPatientEditAddressModal_jsx":1,"modals_ESIPatientEditDetailsModal_ESIPatientEditDetailsModal_jsx":1,"modals_UpdateTask_UpdateTask_jsx-modals_TimerModal_TimerModal_scss":1,"modals_DateRangeSelectionModal_jsx":1,"modals_DateRangeSelectionForEventsReportsModal_jsx":1,"modals_EditCohortModal_EditCohortModal_jsx":1,"modals_EditConditionsModal_EditConditionsModal_jsx":1,"modals_EditFacilitiesModal_EditFacilitiesModal_jsx":1,"modals_SummaryModals_OnboardingModal_jsx":1,"modals_SendMessageModal_SendMessageModal_jsx":1,"modals_EditPatientActionModal_jsx":1,"modals_AccessCareUpdatesModal_jsx":1,"modals_CareUpdatePdfPreviewModal_jsx":1,"modals_SummaryModals_SetupRpmModal_jsx":1,"modals_EulaModal_EulaModal_jsx":1,"modals_TimerModal_TimerModal_scss":1,"modals_WidgetConfigurationModal_WidgetConfigurationModal_jsx":1,"modals_WidgetConfigurationModal_DashboardConfigurationModal_jsx":1,"modals_ResetEnrollmentAndUnattachDevicesModal_jsx":1,"modals_PatientRawDataModal_PatientRawDataModal_jsx":1,"modals_EditDefaultRemindersModal_EditDefaultRemindersModal_jsx":1,"modals_CompositeGraphConfigurationModal_jsx":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr